import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'

import { cn } from '@/utils'

import { TFilterOption } from './FiltersSheetTypes'

export type TRadioFilterProps = {
	title: string
	options: TFilterOption[]
	selectedValue?: string
	onChange: (value: string) => void
}

export const RadioFilter = ({
	title,
	options,
	selectedValue,
	onChange,
}: TRadioFilterProps) => {
	return (
		<div>
			<h3 className="type-body-medium mb-4 font-semibold text-dark-grey">
				{title}
			</h3>
			<RadioGroupPrimitive.Root
				value={selectedValue || ''}
				onValueChange={onChange}
				className="flex flex-col"
			>
				{options.map((option) => {
					const isSelected = selectedValue === option.value
					return (
						<label
							key={option.value}
							className="flex cursor-pointer items-center gap-2 p-2"
						>
							<RadioGroupPrimitive.Item
								value={option.value}
								id={option.value}
								className={cn(
									'flex h-6 w-6 items-center justify-center rounded-full',
									!isSelected && 'border border-grey',
								)}
							>
								<RadioGroupPrimitive.Indicator className="relative h-6 w-6 rounded-full bg-blue">
									<div className="absolute left-1/2 top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white" />
								</RadioGroupPrimitive.Indicator>
							</RadioGroupPrimitive.Item>
							<span className="type-body-small text-dark-grey">
								{option.label}
							</span>
						</label>
					)
				})}
			</RadioGroupPrimitive.Root>
		</div>
	)
}
